export default __webpack_public_path__ + "static/media/community-bottomborder.c0cbabc7.svg";